// A marca do borainbox: o MESMO desenho da landing e do painel antigo — o
// "borainbox" em Fraunces itálico 900 e o ponto acid no alto, depois do "x".
//
// Um lugar só (2026-09-25, apontado pelo Bruno): o painel novo desenhava a
// marca à mão em quatro telas (a casca, entrar, criar conta, convite), com o
// ponto NA FRENTE e a Fraunces reta — a marca mudava de cara entre o site e o
// painel. O texto segue a cor do tema (`currentColor`); o ponto é o acid da
// marca nos dois temas, como no painel antigo.
export function Logo({ altura = 30, className }: { altura?: number; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 1050 280" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="borainbox"
      style={{ height: altura, width: 'auto', display: 'block' }}>
      <text x="40" y="220" fill="currentColor" fontFamily="'Fraunces', Georgia, serif" fontStyle="italic" fontWeight={900} fontSize={200} letterSpacing={-8}>borainbox</text>
      <circle cx="945" cy="75" r="18" fill="#d4ff00" />
    </svg>
  );
}
